import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type Category = {
  id: number;
  name: string;
  slug: string;
  children?: Category[];
};

type IMenuItem = {
  id: number;
  title: string;
  url: string;
  columnItemItems?: IMenuItem[];
};

export type MegaMenuColumn = {
  id: number;
  columnItems: IMenuItem[];
};

export function buildMegaMenuColumns(categories: Category[]): MegaMenuColumn[] {
  return categories.map((top): MegaMenuColumn => ({
    id: top.id,
    columnItems: top.children?.map((mid): IMenuItem => ({
      id: mid.id,
      title: mid.name,
      url: `/categories/${mid.slug}`,
      columnItemItems: mid.children?.map((leaf): IMenuItem => ({
        id: leaf.id,
        title: leaf.name,
        url: `/categories/${leaf.slug}`,
      })) ?? [],
    })) ?? [],
  }));
}

export function searchParamsToObject(params: URLSearchParams): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}
